import type { CompleteKundali } from '../types/kundali';

// A stable profile ID is required for persistent event storage. When no stable ID exists,
// use object identity only for the current mounted chart so equal names/birth details do not
// cause one family member's unsaved BTR events to be reused for another.
const ephemeralKeys = new WeakMap<object, Map<string, string>>();
let nextEphemeralKey = 0;

export function getBtrProfileInstanceKey(
  kundali: CompleteKundali | null | undefined,
  userId?: string | null
): string {
  const userScope = userId || 'guest';
  if (!kundali) return `${userScope}:no-profile`;

  const stableProfileId = userId ? (kundali.id || (kundali.birthDetails as any)?.profileId) : null;
  if (stableProfileId) {
    return `${userScope}:profile:${String(stableProfileId)}`;
  }

  let userKeys = ephemeralKeys.get(kundali as object);
  if (!userKeys) {
    userKeys = new Map<string, string>();
    ephemeralKeys.set(kundali as object, userKeys);
  }

  let instanceKey = userKeys.get(userScope);
  if (!instanceKey) {
    instanceKey = `${userScope}:ephemeral:${++nextEphemeralKey}`;
    userKeys.set(userScope, instanceKey);
  }
  return instanceKey;
}
